import { useTanks } from '@api/useTanks'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { ErrorNotification, NotificationMessage } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Form } from 'antd'
import React, { useEffect, useState } from 'react'

import { EditAndSaveControls } from './EditAndSaveControls'
import { TankDetailsForm } from './TankDetailsForm'
import { Volumes } from './Volumes'

export function TankSizing({ tank, metadata, loading, setLoading, gridAPI }) {
  const { scopes } = useSecurityContext()
  const [editing, setEditing] = useState(false)
  const [form] = Form.useForm()
  const [availableManifolds, setAvailableManifolds] = useState([])
  const { updateTankMutation } = useTanks()
  const { mutateAsync: updateMutate } = updateTankMutation()
  const getManifolds = () => {
    api.getStoreManifolds(tank.store_number).then((resp) =>
      setAvailableManifolds(
        resp.data &&
          Object.keys(resp.data).map((key) => ({
            manifold_id: key,
            tanks: resp.data[key],
          }))
      )
    )
  }
  useEffect(() => {
    getManifolds()
    form.setFieldsValue({ ...tank })
  }, [])

  const canEditStores = scopes.admin?.site_write

  const handleSave = (formData) => {
    form.setFieldsValue(formData)
    setLoading(true)

    const setClearedFieldsNull = (formData) => {
      formData.manifold_id = formData.manifold_id ? formData.manifold_id : null
      formData.tank_chart = formData.tank_chart ? formData.tank_chart : null
      return formData
    }
    const updatedTank = {
      ...tank,
      ...setClearedFieldsNull(formData),
      id: undefined,
      backup_id: tank.id,
      manifold_id: formData.manifold_id || null,
    }
    updateMutate(updatedTank)
      .then(() => {
        getManifolds()
        NotificationMessage('Tank Sizing Updated', 'Tank sizing has been successfully updated', false)
        setLoading(false)
        setEditing(false)
        gridAPI.redrawRows()
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div className='store-expand-card flex'>
      <Form
        form={form}
        className='store-info-form full-height-width'
        size='small'
        onFinish={handleSave}
        onFinishFailed={(msg) => {
          ErrorNotification(msg)
          setLoading(false)
        }}
      >
        <div className='flex flex-row full-height-width'>
          <TankDetailsForm availableManifolds={availableManifolds} tank={tank} editing={editing} metadata={metadata} />
          <div className='flex-1 p-3'>
            <EditAndSaveControls
              loading={loading}
              canEditStores={canEditStores}
              editing={editing}
              setEditing={setEditing}
              setLoading={setLoading}
            />
            <Volumes tank={tank} editing={editing} />
          </div>
        </div>
      </Form>
    </div>
  )
}
